import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/deviceCollection/`,
		name: "添加设备收藏",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/deviceCollection/`,
		name: "删除设备收藏",
		delete: async function(data){
			return await http.delete(this.url, data);
		}
	},
    list: {
		url: `${config.API_URL}/deviceCollection/`,
		name: "查询设备收藏列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	}
}
